AGADash.Filter = (function () {
    var innerRender = null;
    var filterClasses = {};

    var setRender = function (render) {
        innerRender = render;
    };

    var setFilterClass = function(name, implementor) {
        filterClasses[name] = implementor;
    };

    var getFilterClass = function(name) {
        return filterClasses[name];
    };
    
    var renderFilters = function (panelId, target) {
        AGADash.callService("/PanelFilters", { "filtersPanel": panelId },
            function (data) {
                var body = $(target).find(".dash-filters")[0];
                $(body).empty();

                if (data.length > 0) {
                    innerRender.render(body, data);
                }
                // se não tem filtros deve atualizar, verifica se não necessita filtros, dai tbm carrega.
                if (data.length === 0 || !AGADash.Panel.getDataFilterRequired(target)) {
                    AGADash.Panel.updatePanel(target);
                }
            },

            function (errorData) {
                AGADash.Panel.renderAjaxError(target, errorData, "Não foi possível ler dados do filtro do painel.");
            });
    };

    return {
        setRender: setRender,
        renderFilters: renderFilters,
        setFilterClass: setFilterClass,
        getFilterClass: getFilterClass
    };
})();
